import { render, staticRenderFns } from "./GarageSelect.vue?vue&type=template&id=18f8d39d&scoped=true"
import script from "./GarageSelect.vue?vue&type=script&lang=js"
export * from "./GarageSelect.vue?vue&type=script&lang=js"
import style0 from "./GarageSelect.vue?vue&type=style&index=0&id=18f8d39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8d39d",
  null
  
)

export default component.exports